export interface FilterView {
    filterDefault: boolean;
    userFilterId: number;
    userFilterName?: string;
    userFilterValue?: any;
}
